import wrappedFetch from './base';

const fetchAddons = () => {
  return wrappedFetch('/addons.json')
    .then((response) => response.json());
};

export default fetchAddons;
